import React, { useState, useEffect } from "react";
import "./footer.css";

import Facebook from "../../assets/footer/footer_fb.svg";
import Instagram from "../../assets/footer/footer_insta.svg";
import Twitter from "../../assets/footer/footer_twitter.svg";
import Pinterest from "../../assets/footer/footer_pinterest.svg";
import Call from "../../assets/footer/footer_call.svg";
import Mail from "../../assets/footer/footer_mail.svg";
import Header from "../../assets/footer/footer_center.svg";

import { useNavigate } from "react-router";

import { ApiHelper } from "../../utilFunctions/utilfunction";

const Footer = () => {
  let navigate = useNavigate();

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [facebook, setFacebook] = useState();
  const [twitter, setTwitter] = useState();
  const [insta, setInsta] = useState();
  const [pinterest, setPinterest] = useState();

  useEffect(async () => {
    let email_url = "/get_contact_detils/contect_email";
    let email_data = await ApiHelper(email_url);
    setEmail(email_data);

    let contact_url = "/get_contact_detils/contect_number";
    let contact_data = await ApiHelper(contact_url);
    setContact(contact_data);

    let facebook_url = "/get_contact_detils/facebook_url";
    let facebook_data = await ApiHelper(facebook_url);
    setFacebook(facebook_data);

    let twitter_url = "/get_contact_detils/twitter_url";
    let twitter_data = await ApiHelper(twitter_url);
    setTwitter(twitter_data);

    let insta_url = "/get_contact_detils/instagram_url";
    let insta_data = await ApiHelper(insta_url);
    setInsta(insta_data);

    let pinterest_url = "/get_contact_detils/pinterest_url";
    let pinterest_data = await ApiHelper(pinterest_url);
    setPinterest(pinterest_data);
  }, []);

  return (
    <section className="footer container pt-5 pb-4 ps-lg-0 pe-lg-0">
      {/* <div className="text-center heading_footer_logo">
        <img className="brand_logo2 mw-100" src={Header} alt="header" />
      </div> */}

      {/* <div className="d-flex justify-content-center align-items-center flex-column flex-lg-row">
        <a
          onClick={() => navigate("/vintage-rolex-watches")}
          className="fs-14 fw-500 for_padding text-decoration-none text-dark cursor-pointer"
        >
          Vintage Rolex Watches
        </a>
        <a
          onClick={() => navigate("/sell-your-watch")}
          className="fs-14 fw-500 for_padding text-decoration-none text-dark cursor-pointer"
        >
          Sell your Watch
        </a>
        <a
          onClick={() => navigate("/archive-articles")}
          className="fs-14 fw-500 for_padding text-decoration-none text-dark cursor-pointer"
        >
          Articles
        </a>
        <a
          onClick={() => navigate("/blog")}
          className="fs-14 fw-500 for_padding text-decoration-none text-dark cursor-pointer"
        >
          Blogs
        </a>
        <a
          onClick={() => navigate("/contact-us")}
          className="fs-14 fw-500 for_padding text-decoration-none text-dark cursor-pointer"
        >
          Contact us
        </a>
        <a
          onClick={() => navigate("/privacy-policy")}
          className="fs-14 fw-500 for_padding text-decoration-none text-dark cursor-pointer"
        >
          Privacy Policy
        </a>
        Please do not hesitate to contact me should you wish to discuss selling your watch via
      </div> */}
      <div className="d-flex flex-column flex-lg-col align-items-center justify-content-center pb-2">
        <div className=" fs-14 fw-500 d-flex align-items-center text-decoration-none text-dark" >
          Please do not hesitate to contact me should you wish to discuss selling your watch via
        </div>
        <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center pb-2">
          {email ? (
            <>
              <a
                className=" fs-14 fw-500 d-flex align-items-center text-decoration-none text-dark"
                href={`mailto:${email.data.setting_value}`}
              >
                <svg
                  className="for_padding2 email2"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.1"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12Z"
                    fill="#18191F"
                  />
                  <path
                    d="M7 8L13 12.2857L19 8M7 16.5714H19V8H7V16.5714Z"
                    stroke="#262626"
                    strokeWidth="0.857143"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="for_padding2">{email.data.setting_value}</span>
              </a>
            </>
          ) : (
            ""
          )}

          {contact ? (
            <a
              className=" fs-14 fw-500 d-flex align-items-center text-decoration-none text-dark"
              href={`tel:${contact.data.setting_value}`}
            >
              <svg
                className="for_padding2 footer_icon2"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.1"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12Z"
                  fill="#18191F"
                />
                <path
                  d="M17.6198 18H17.5413C8.47209 17.4785 7.1844 9.82615 7.0044 7.49077C6.98989 7.30919 7.01136 7.12653 7.06757 6.95327C7.12378 6.78 7.21362 6.61952 7.33196 6.48104C7.45029 6.34255 7.59479 6.22878 7.75717 6.14623C7.91955 6.06369 8.09662 6.01399 8.27824 6H10.8213C11.0062 5.99982 11.1869 6.05516 11.3399 6.15884C11.493 6.26253 11.6114 6.40979 11.6798 6.58154L12.3813 8.30769C12.4489 8.47548 12.4656 8.65942 12.4295 8.83666C12.3934 9.01389 12.306 9.17662 12.1782 9.30462L11.1952 10.2969C11.3487 11.1696 11.7666 11.974 12.3923 12.6014C13.0181 13.2287 13.8214 13.6488 14.6936 13.8046L15.6952 12.8123C15.8251 12.6859 15.9893 12.6006 16.1674 12.5669C16.3456 12.5333 16.5296 12.5528 16.6967 12.6231L18.4367 13.32C18.6059 13.3906 18.7502 13.5099 18.8513 13.6628C18.9524 13.8157 19.0057 13.9952 19.0044 14.1785V16.6154C19.0044 16.9826 18.8585 17.3348 18.5989 17.5945C18.3392 17.8541 17.987 18 17.6198 18ZM8.38901 6.92308C8.2666 6.92308 8.14921 6.9717 8.06265 7.05826C7.9761 7.14481 7.92747 7.26221 7.92747 7.38462V7.42154C8.13978 10.1538 9.50132 16.6154 17.5921 17.0769C17.6527 17.0807 17.7135 17.0724 17.7709 17.0526C17.8284 17.0328 17.8813 17.0019 17.9268 16.9616C17.9722 16.9213 18.0093 16.8724 18.0358 16.8177C18.0623 16.7631 18.0778 16.7037 18.0813 16.6431V14.1785L16.3413 13.4815L15.0167 14.7969L14.7952 14.7692C10.7798 14.2662 10.2352 10.2508 10.2352 10.2092L10.2075 9.98769L11.5182 8.66308L10.8259 6.92308H8.38901Z"
                  fill="black"
                />
              </svg>
              <span className="for_padding2">
                {contact.data.setting_value}
              </span>
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
      <hr className="hr_class"></hr>
      <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center justify-content-lg-between">
        <p className="text-center fs-14 fw-500">
          © {new Date().getFullYear()} Vintage Rolex Sports Watches. All rights reserved.
        </p>

        <p>
          {insta ? (
            <a
              className="cursor-pointer"
              target="_blank"
              href={`${insta.data.setting_value}`}
            >
              <svg
                className="icon2 mx-2"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.1"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
                  fill="#18191F"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.0006 5.59998C10.2625 5.59998 10.0443 5.60758 9.36165 5.63864C8.68031 5.66984 8.21523 5.77771 7.8083 5.93598C7.38736 6.09945 7.03029 6.31812 6.67455 6.67399C6.31855 7.02972 6.09988 7.38679 5.93588 7.8076C5.77721 8.21467 5.66921 8.67987 5.63854 9.36095C5.60801 10.0436 5.60001 10.2619 5.60001 12C5.60001 13.7382 5.60774 13.9557 5.63867 14.6383C5.67001 15.3197 5.77787 15.7847 5.93601 16.1917C6.09961 16.6126 6.31828 16.9697 6.67415 17.3254C7.02975 17.6814 7.38682 17.9006 7.8075 18.0641C8.2147 18.2224 8.6799 18.3302 9.36111 18.3614C10.0438 18.3925 10.2618 18.4001 11.9998 18.4001C13.7381 18.4001 13.9556 18.3925 14.6382 18.3614C15.3196 18.3302 15.7852 18.2224 16.1924 18.0641C16.6132 17.9006 16.9697 17.6814 17.3253 17.3254C17.6813 16.9697 17.9 16.6126 18.064 16.1918C18.2213 15.7847 18.3293 15.3195 18.3613 14.6385C18.392 13.9558 18.4 13.7382 18.4 12C18.4 10.2619 18.392 10.0438 18.3613 9.36108C18.3293 8.67974 18.2213 8.21467 18.064 7.80773C17.9 7.38679 17.6813 7.02972 17.3253 6.67399C16.9693 6.31798 16.6133 6.09931 16.192 5.93598C15.784 5.77771 15.3186 5.66984 14.6373 5.63864C13.9546 5.60758 13.7373 5.59998 11.9986 5.59998H12.0006ZM11.4264 6.7533C11.5968 6.75304 11.787 6.7533 12.0006 6.7533C13.7094 6.7533 13.9119 6.75944 14.5867 6.7901C15.2107 6.81864 15.5494 6.9229 15.775 7.01051C16.0737 7.12651 16.2866 7.26517 16.5105 7.48918C16.7345 7.71318 16.8732 7.92652 16.9894 8.22518C17.077 8.45052 17.1814 8.78919 17.2098 9.4132C17.2405 10.0879 17.2472 10.2905 17.2472 11.9986C17.2472 13.7066 17.2405 13.9092 17.2098 14.5839C17.1813 15.2079 17.077 15.5466 16.9894 15.7719C16.8734 16.0706 16.7345 16.2833 16.5105 16.5071C16.2865 16.7311 16.0738 16.8698 15.775 16.9858C15.5497 17.0738 15.2107 17.1778 14.5867 17.2063C13.9121 17.237 13.7094 17.2437 12.0006 17.2437C10.2916 17.2437 10.0891 17.237 9.41442 17.2063C8.79041 17.1775 8.45174 17.0733 8.22601 16.9857C7.92734 16.8697 7.714 16.731 7.49 16.507C7.266 16.283 7.12733 16.0702 7.01106 15.7714C6.92346 15.5461 6.81906 15.2074 6.79066 14.5834C6.75999 13.9087 6.75386 13.706 6.75386 11.997C6.75386 10.2879 6.75999 10.0863 6.79066 9.4116C6.81919 8.78759 6.92346 8.44892 7.01106 8.22332C7.12706 7.92465 7.266 7.71131 7.49 7.48731C7.714 7.26331 7.92734 7.12464 8.22601 7.00837C8.45161 6.92037 8.79041 6.81637 9.41442 6.7877C10.0048 6.76104 10.2336 6.75304 11.4264 6.7517V6.7533ZM15.4169 7.81598C14.9929 7.81598 14.6489 8.15959 14.6489 8.58372C14.6489 9.00773 14.9929 9.35173 15.4169 9.35173C15.8409 9.35173 16.1849 9.00773 16.1849 8.58372C16.1849 8.15972 15.8409 7.81598 15.4169 7.81598ZM12.0006 8.71332C10.1855 8.71332 8.71392 10.1849 8.71392 12C8.71392 13.8151 10.1855 15.2861 12.0006 15.2861C13.8157 15.2861 15.2868 13.8151 15.2868 12C15.2868 10.1849 13.8157 8.71332 12.0006 8.71332ZM12.0006 9.86667C13.1787 9.86667 14.1339 10.8217 14.1339 12C14.1339 13.1782 13.1787 14.1334 12.0006 14.1334C10.8223 14.1334 9.86724 13.1782 9.86724 12C9.86724 10.8217 10.8223 9.86667 12.0006 9.86667Z"
                  fill="#18191F"
                />
              </svg>
            </a>
          ) : (
            ""
          )}
        </p>
      </div>
    </section>
  );
};

export default Footer;
